var _rect, _mask, _path, _tspan, _rect2, _tspan2, _rect3, _tspan3, _rect4, _tspan4, _rect5, _tspan5, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 333,
    viewBox: "0 0 411 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1418_8155)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1418_8155)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10.5342,
    width: 370,
    height: 292,
    rx: 10,
    className: "component-background"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1418_8155)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1418_8155",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.5342C20.5 13.2205 23.1863 10.5342 26.5 10.5342H384.5C387.814 10.5342 390.5 13.2205 390.5 16.5342V58.5342H20.5V16.5342Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.5342H390.5H20.5ZM390.5 59.5342H20.5V57.5342H390.5V59.5342ZM20.5 58.5342V10.5342V58.5342ZM390.5 10.5342V58.5342V10.5342Z",
    fill: "white",
    fillOpacity: 0.15,
    mask: "url(#path-3-inside-1_1418_8155)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 43.2442
  }, "BORDER BUTTON")))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1418_8155)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 69.0342,
    width: 349,
    height: 39,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 181.6,
    y: 91.6742
  }, "NORMAL")))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 129.034,
    width: 349,
    height: 39,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.719,
    y: 151.674
  }, "PRESSED")))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1418_8155)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 187.534,
    width: 352,
    height: 42,
    rx: 7,
    stroke: "#FFD600",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.66,
    y: 211.674
  }, "FOCUSED")))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 249.034,
    width: 349,
    height: 39,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 177.346,
    y: 271.674
  }, "DISABLED"))))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11.0342,
    width: 369,
    height: 291,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1418_8155",
    x: 0.5,
    y: 0.53418,
    width: 410,
    height: 332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1418_8155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1418_8155",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1418_8155",
    x: 10.5,
    y: 5.53418,
    width: 390,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1418_8155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1418_8155",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1418_8155",
    x: 10.5,
    y: 58.5342,
    width: 390,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1418_8155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1418_8155",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1418_8155",
    x: 8.5,
    y: 176.534,
    width: 394,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1418_8155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1418_8155",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_8155"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10.5342,
    width: 370,
    height: 292,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderbutton);
export default __webpack_public_path__ + "static/media/borderbutton.61703fcdbc77b35d458fb85bcd6e343e.svg";
export { ForwardRef as ReactComponent };